//imports
import {
    DATA_DETAILS_OPEN_MODAL,
    DATA_DETAILS_CLOSE_MODAL,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    data: null,
    openModal: false,
}

//DATA redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case DATA_DETAILS_OPEN_MODAL:
            return { ...state, openModal: true, data: action.payload }

        case DATA_DETAILS_CLOSE_MODAL:
            return { ...state, openModal: false, data: null }

        case CLEAR_REDUX:
            return ["", "DATA_DETAILS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};